interface SpinnerProps {
  className?: string;
}

export function Spinner({ className = '' }: SpinnerProps) {
  return (
    <span
      role="status"
      aria-label="loading"
      className={`inline-block h-4 w-4 animate-spin rounded-full border-[3px] border-conduril border-t-transparent ${className}`}
    />
  );
}
